import React, { useState, useEffect } from 'react';
import {
  Typography, IconButton,
  Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Box, Container, Stack, Dialog, DialogActions, DialogContent, DialogTitle, TextField,
  Snackbar, Alert
} from '@mui/material';
import Pagination from '@mui/material/Pagination';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import BurgerBar from '../Materials/BurgerBar';
import Footer from '../Materials/Footer';

export default function CreateEntityListPage() {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [entities, setEntities] = useState([]);
  const [openFirstDeleteDialog, setOpenFirstDeleteDialog] = useState(false); // Primeiro diálogo de confirmação
  const [openSecondDeleteDialog, setOpenSecondDeleteDialog] = useState(false); // Segundo diálogo de confirmação
  const [entityToDelete, setEntityToDelete] = useState(null); // Para armazenar a entidade a ser excluída
  const [entityNameToDelete, setEntityNameToDelete] = useState(''); // Para armazenar o nome da entidade a ser excluída
  const [inputNameForDeletion, setInputNameForDeletion] = useState(''); // Para armazenar o nome digitado pelo usuário
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const showNotification = (message, severity = 'success') => {
    setNotification({
      open: true,
      message,
      severity
    });
  };

  const handleCloseNotification = () => {
    setNotification((prev) => ({
      ...prev,
      open: false
    }));
  };

  // Paginação
  const [page, setPage] = useState(1);
  const entitiesPerPage = 10;

 
  const handleCreateEntityClick = () => {
    navigate('/createentity'); // Aqui é o caminho para a página de criação detalhada
  };

  const fetchEntities = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/entities');
      if (!response.ok) {
        throw new Error('Erro ao buscar as entidades');
      }
      const data = await response.json();
      setEntities(data);
    } catch (error) {
      console.error('Erro ao buscar entidades:', error);
    }
  };

  // Função para excluir a entidade
  const handleDeleteEntity = async (id) => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/entities/${id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Erro ao excluir a entidade');
      }

      // Após a exclusão, fechamos o dialog e atualizamos a lista
      setEntities(entities.filter(entity => entity.id !== id));
      setOpenSecondDeleteDialog(false);
    } catch (error) {
      showNotification('Erro ao excluir a entidade', 'error');
    }
  };

  const handleOpenDeleteDialog = (entityId, entityName) => {
    setEntityToDelete(entityId);  // Armazenar o id da entidade a ser excluída
    setEntityNameToDelete(entityName); // Armazenar o nome da entidade
    setInputNameForDeletion(''); // Limpar o campo de texto
    setOpenFirstDeleteDialog(true);     // Abrir o primeiro Dialog
  };

  const handleCloseFirstDeleteDialog = () => {
    setOpenFirstDeleteDialog(false);  // Fechar o primeiro Dialog
  };

  const handleCloseSecondDeleteDialog = () => {
    setOpenSecondDeleteDialog(false);  // Fechar o segundo Dialog
    setEntityToDelete(null);            // Limpar a entidade selecionada
    setEntityNameToDelete('');          // Limpar o nome da entidade
    setInputNameForDeletion('');        // Limpar o campo de texto
  };

  const handleConfirmFirstDelete = () => {
    setOpenFirstDeleteDialog(false);  // Fechar o primeiro Dialog
    setOpenSecondDeleteDialog(true);  // Abrir o segundo Dialog
  };

  const handleInputChange = (event) => {
    setInputNameForDeletion(event.target.value);  // Atualiza o valor do campo de texto
  };

  const handleConfirmDeletion = () => {
    if (inputNameForDeletion === entityNameToDelete) {
      handleDeleteEntity(entityToDelete);  // Exclui a entidade
    } else {
      showNotification('O nome da entidade não corresponde. Tente novamente.', 'warning');
    }
  };

  useEffect(() => {
    fetchEntities();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/users'); // Ajuste a URL conforme necessário  
      if (!response.ok) {  
        throw new Error('Erro ao buscar os usuários');  
      }  
      const data = await response.json();  
      setUsers(data);  
    } catch (error) {  
      console.error('Erro ao buscar usuários:', error);  
    }  
  };  
  
  useEffect(() => {  
    fetchEntities();  
    fetchUsers();  
  }, []);  
  
  // Função para obter o nome do usuário pelo ID  
  const getUserNameById = (userId) => {  
    const user = users.find(user => user.id === userId);  
    return user ? user.name : 'Unknown User'; // Se não encontrar, retorna "Unknown User"  
  }; 
 
  // Paginação das entidades 
  const totalPages = Math.ceil(entities.length / entitiesPerPage); 
  const startIndex = (page - 1) * entitiesPerPage; 
  const paginatedEntities = entities.slice( 
    startIndex, 
    startIndex + entitiesPerPage 
  ); 
  
  return (  
    <Box sx={{ flexGrow: 1 }}>  
      <BurgerBar />  
  
      <Container maxWidth="lg" sx={{ mt: 4 }}>  
        <Paper sx={{ p: 3 }}>  
          <Button  
            variant="contained"  
            color="primary"  
            startIcon={<AddIcon />}  
            sx={{ mt: 2, mb: 2 }}  
            onClick={handleCreateEntityClick}  
          >  
            New Entity  
          </Button>  
  
          <TableContainer>  
            <Table>  
              <TableHead>  
                <TableRow>  
                  <TableCell align="center">Name</TableCell>  
                  <TableCell align="center">Head Office</TableCell>  
                  <TableCell align="center">Main Location</TableCell>  
                  <TableCell align="center">Created By</TableCell>  
                  <TableCell align="center">Actions</TableCell>  
                </TableRow>  
              </TableHead>  
              <TableBody>  
                {paginatedEntities.map((entity, index) => (  
                  <TableRow key={index}>  
                    <TableCell align="center">{entity.name}</TableCell>  
                    <TableCell align="center">{entity.head_office}</TableCell>  
                    <TableCell align="center">{entity.main_location}</TableCell>  
                    <TableCell align="center">{getUserNameById(entity.created_by)}</TableCell>  
                    <TableCell align="center">  
                      <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">  
                        <IconButton  
                          color="primary"  
                          onClick={() => navigate('/editDetailedEntities', { state: { entityId: entity.id } })}  
                        >  
                          <EditIcon />  
                        </IconButton>  
                        <IconButton 
                          color="error" 
                          onClick={() => handleOpenDeleteDialog(entity.id, entity.name)} 
                        >  
                          <DeleteIcon />  
                        </IconButton>  
                      </Stack>  
                    </TableCell>  
                  </TableRow>  
                ))}  
              </TableBody>  
            </Table>  
          </TableContainer> 
 
          {/* Paginação */} 
          {totalPages > 1 && ( 
            <Box 
              sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                mt: 4, 
                mb: 2 
              }} 
            > 
              <Pagination 
                count={totalPages} 
                page={page} 
                onChange={(event, value) => setPage(value)} 
                color="primary" 
                shape="rounded" 
                showFirstButton 
                showLastButton 
              /> 
            </Box> 
          )} 
 
        </Paper>  
      </Container>  
  
      {/* Primeiro Dialog de confirmação */}  
      <Dialog  
        open={openFirstDeleteDialog}  
        onClose={handleCloseFirstDeleteDialog}  
      >  
        <DialogTitle>Confirm Deletion</DialogTitle>  
        <DialogContent>  
          <Typography variant="body1">  
            Are you sure you want to delete the entity "{entityNameToDelete}"?  
          </Typography>  
        </DialogContent>  
        <DialogActions>  
          <Button onClick={handleCloseFirstDeleteDialog} color="primary">  
            Cancel  
          </Button>  
          <Button onClick={handleConfirmFirstDelete} color="error">  
            Confirm  
          </Button>  
        </DialogActions>  
      </Dialog>  
  
      {/* Segundo Dialog de confirmação */}  
      <Dialog  
        open={openSecondDeleteDialog}  
        onClose={handleCloseSecondDeleteDialog}  
      >  
        <DialogTitle>Final Confirmation</DialogTitle>  
        <DialogContent>  
          <Typography variant="body1">  
            To delete the entity "{entityNameToDelete}", type the entity's name below:  
          </Typography>  
          <TextField  
            fullWidth  
            value={inputNameForDeletion}  
            onChange={handleInputChange}  
            label="Type entity name"  
            sx={{ mt: 2 }}  
          />  
        </DialogContent>  
        <DialogActions>  
          <Button onClick={handleCloseSecondDeleteDialog} color="primary">  
            Cancel  
          </Button>  
          <Button onClick={handleConfirmDeletion} color="error">  
            Delete  
          </Button>  
        </DialogActions>  
      </Dialog>

      <Snackbar
        open={notification.open}
        autoHideDuration={4000}
        onClose={handleCloseNotification}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
  
      <Box>  
        <Footer>  
  
        </Footer>  
      </Box>  
    </Box>  
  
  );  
}